
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 11.5008L12.4356 18.635C11.5089 19.509 10.252 20 8.94144 20C7.63089 20 6.37401 19.509 5.44731 18.635C4.52061 17.761 4 16.5756 4 15.3396C4 14.1036 4.52061 12.9182 5.44731 12.0442L13.0117 4.91C13.6295 4.32734 14.4675 4 15.3412 4C16.2149 4 17.0528 4.32734 17.6706 4.91C18.2884 5.49266 18.6355 6.28292 18.6355 7.10693C18.6355 7.93094 18.2884 8.7212 17.6706 9.30386L10.0979 16.4381C9.78902 16.7294 9.37006 16.8931 8.93321 16.8931C8.49636 16.8931 8.0774 16.7294 7.7685 16.4381C7.4596 16.1467 7.28606 15.7516 7.28606 15.3396C7.28606 14.9276 7.4596 14.5325 7.7685 14.2411L14.7568 7.6581","stroke":"#10001F","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    